module.exports = __webpack_public_path__ + "img/汗.2b5d5633.png";